package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_03_24_Day_1
import com.veldekar.components.logs.Log_2023_03_24_Day_2
import com.veldekar.components.logs.Log_2023_03_24_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-03-24")
@Composable
public fun Log_2023_03_24(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "A Visit from Lalia",
        ogTitle = "A Visit from Lalia",
        date = LocalDate(2_023, 3, 24),
        ogDescription = "After a strange encounter with a statue of Gildora, the heroes are visited by the Erinyes Lalia with a warning.",
        ogImage = "ai/2023-03-24.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-18", dateString = "Newgrowth 18")
        Log_2023_03_24_Day_1()
        SessionDayHeader(dayId = "newgrowth-19", dateString = "Newgrowth 19")
        Log_2023_03_24_Day_2()
        SessionDayHeader(dayId = "newgrowth-21", dateString = "Newgrowth 21")
        Log_2023_03_24_Day_3()
    }
}
